import React from "react";
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

// material ui
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TableFooter from "@mui/material/TableFooter";
import TextField from "@mui/material/TextField";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import { Link, useLocation } from "react-router-dom";

// iconos
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import DoneOutlineRounded from "@mui/icons-material/DoneOutlineRounded";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import AppRegistrationOutlinedIcon from '@mui/icons-material/AppRegistrationOutlined';
import SearchIcon from "@mui/icons-material/Search";
import CheckIcon from '@mui/icons-material/Check';

// servicios / componentes
import { setError } from "../../reducers/appSlice";
import api from "../../service/api";
import Page from "../../layout/Page";
import ReporteSeguidos from './ReporteSeguidos';
import BotonSeguir from '../verTramite/BotonSeguir';




const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButtonGroup-grouped": {
    margin: theme.spacing(0.5),
    border: 0,
    "&.Mui-disabled": {
      border: 0,
    },
    "&:not(:first-of-type)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-of-type": {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

const TabContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    paddingRight: theme.spacing(0),
    paddingLeft: theme.spacing(0),
  },
}));

const Row = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const leyendaTema =
  "Podés buscar directamente por código o acceder al buscador ampliado en la lupa.";

const TableCellHead = styled(TableCell)(({ theme }) => ({
  color: "#3c4b64",
}));

const TablePaginationActions = (props) => {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  
  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
            <KeyboardArrowLeft />
          )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
            <KeyboardArrowRight />
          )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const ConsultaSeguir = (props) => {


  const location = useLocation();
  var validationSchema = Yup.object().shape({});

  const [selected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [tramiteNoEncontrado, setTramiteNoEncontrado] = useState(true);
  const [tramiteId, setTramiteId] = useState(0);
  const [expedientes, setExpedientes] = useState([]);
  const [sinFolio, setSinFolio] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [filter, setFilter] = useState("");
  const [filteredExp, setFilteredExp] = useState([]);
  const dispatch = useDispatch();
  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    { nombre: "Seguimiento de expedientes", ruta: "" },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  const formik = useFormik({
    initialValues: {
      id_tramite: props.id,
      organismo: "",
      codigoOrganismo: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => { },
    onReset: () => { },
  });

  const formik2 = useFormik({
    initialValues: {
      idTramite: '',
      nroExpediente: '',
      asunto: '',
      soporte: '',
      fecha: '',
      situacion: '',
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => { 
      // agregarTramiteFila();
    },
    onReset: () => { },
  });

 
 const buscarTramite = async (nro) => {

      let filtro = {
        nroExpediente: nro
      };
      await api.consultaExpedientes(filtro)
        .then((res) => {

          if (res.data.length > 0){

            setTimeout( () => {

              let agregado = {
                tramiteId: res.data[0].tramiteId ? res.data[0].tramiteId: null,
                numero: res.data[0].nroExpediente ? res.data[0].nroExpediente: null,
                soporte: res.data[0].soporte ? res.data[0].soporte : null,
                asunto: res.data[0].asunto ? res.data[0].asunto : null,
                folios: res.data[0].folios ? res.data[0].folios : null,
                situacion: res.data[0].situacion ? res.data[0].situacion : null
              };
          
              for (let index = 0; index < filteredExp.length; index++) {
                const elemento = filteredExp[index];
                if (elemento.numero !== null && elemento.numero === agregado.numero) {
                  //setWarning('El expediente ya está agregado en la lista')
                  dispatch(setError('El expediente ya está agregado en la lista'));
                  return;
                }
              };
              
              filteredExp.unshift(agregado);
              //setExpedientes((prevState) => [...prevState, agregado]);
              formik2.setFieldValue('nroExpediente', '');
              //console.log(expedientes);
            },500);

          }else{
             dispatch(setError('El expediente N° \"'+nro+'\" no existe'));
          }
        })  
         .catch((e) => {
          dispatch(setError("El expediente que estás buscando no existe."));
          setTramiteId(0);
          setTramiteNoEncontrado(true);
          setSinFolio(true);
        });

  };

  const buscarSuscripciones = () => {

    api.consultaSuscripciones()
    .then((res) => {

      let suscripciones = res.data;
      setExpedientes([...suscripciones]);
      setFilteredExp([...suscripciones])
    })  
     .catch((e) => {
      console.log(e);
      dispatch(setError(e));
    });
  };

  const handleChangeNumeroTramite = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      formik2.setFieldValue(event.target.id, event.target.value);
    }
  };

  const handleNumeroTramite = (event) => {
    // verifica si se da un enter o tab
    if (event.keyCode === 13 || event.keyCode === 9) {
      if (event.target.value !== "" && event.target.value !== null) {
        buscarTramite(event.target.value);                    
      }
      else{
      setTramiteNoEncontrado(true);
      setSinFolio(true);
      }
    }
  };

  const handleNumeroTramiteButton = () => {
   
      if (formik2.values.nroExpediente !== "" && formik2.values.nroExpediente !== null) {
        buscarTramite(formik2.values.nroExpediente);                    
      }
      else{
      setTramiteNoEncontrado(true);
      setSinFolio(true);
      }
    
  };

  const handleQuitar = (index) => {
    let expedientesAux = [...filteredExp];
    expedientesAux.splice(index, 1);
    setFilteredExp([...expedientesAux]);
  };

  const handleFilter = (event) => {
    setFilter(event.target.value);
  };

  const filterData = (element) => {
    return (element.asunto.toLowerCase().includes(filter.toLowerCase()) || element.numero.toLowerCase().includes(filter.toLowerCase())
    || element.soporte.toLowerCase().includes(filter.toLowerCase()) || element.situacion.toLowerCase().includes(filter.toLowerCase()));
  };

  useEffect(() => {
    if (filter) {
      setFilteredExp(expedientes.filter(motivo => filterData(motivo)));
    } else {
      setFilteredExp(expedientes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => { 
     // cuando arranca la pantalla traemos los expedientes donde estamos suscriptos
     buscarSuscripciones();
  }, []);

  return (
    <Page breadcrumbs={breadcrumbs}>
      <TabContainer>
      <form
        id="formBusquedaExpediente"
        name="formBusquedaExpediente"
        onSubmit={formik2.handleSubmit}
        onReset={formik2.handleReset}
        noValidate
        autoComplete="off"
      >
      <Row container spacing={1} sx={{ marginBottom: 1 }}>
            <Grid item xs={10} lg={3}>
              <TextField
                id="nroExpediente"
                name="nroExpediente"
                label="Expediente a seguir"
                variant="outlined"
                size="small"
                inputProps={{ maxLength: 8 }}
                fullWidth
                autoFocus
                value={formik2.values.nroExpediente}
                onChange={handleChangeNumeroTramite}
                onBlur={handleNumeroTramite}
                onKeyDown={handleNumeroTramite}
                error={
                  formik2.touched.nroExpediente &&
                  Boolean(formik2.errors.nroExpediente)
                }
                helperText={
                  formik2.touched.nroExpediente && formik2.errors.nroExpediente
                }
              />
            </Grid>
            <Grid item xs={2} lg={2}>
                  <Box sx={{ display: { xs: "none", sm: "block" }}}>
                    <Button
                      variant="gris"
                      type="button"
                      onClick={handleNumeroTramiteButton}
                      //disabled={submitting || loading}
                      sx={{ m: 0.3 }}
                      endIcon={<CheckIcon />}
                    >
                     Agregar
                    </Button>
                  </Box>
                  <Box sx={{ display: { xs: "block", sm: "none" }}}>
                    <Grid align="right">
                      <IconButton
                        color="primary"
                        type="button"
                        onClick={handleNumeroTramiteButton}
                       // disabled={submitting || loading}
                        title="Buscar"
                      >
                        <CheckIcon />
                      </IconButton>
                    </Grid>
                  </Box>
              </Grid>
      </Row>
      </form>
      <Toolbar disableGutters>
        <Grid container spacing={1} align="left">
          <Grid item align="left">
            <Paper
              elevation={0}
              sx={{
                display: "flex",
                border: (theme) => `1px solid ${theme.palette.divider}`,
                flexWrap: "wrap",
              }}
            >
              <StyledToggleButtonGroup
                      size="small"
                      exclusive
                      aria-label="text accionGrupal"
                    >
                      <ReporteSeguidos datos={filteredExp} />
                </StyledToggleButtonGroup> 
            </Paper>
            </Grid>
            <Grid item xs={10} lg={2}>
            <TextField
                    id="filtro"
                    name="filtro"
                    label="Buscar"
                    variant="outlined"
                    size="small"
                    inputProps={{ maxLength: 8 }}
                    fullWidth
                    value={filter}
                    onChange={handleFilter}
                  />
            </Grid>
            </Grid>
      </Toolbar>       
        <TableContainer>
          <Table
            aria-label="tabla movimientos"
            sx={{ border: "1px solid #dee2e6" }}
            size="small"
          >
            <TableHead>
              <TableRow>
                <TableCellHead align="center" padding="normal">
                  <b>Expediente</b>
                </TableCellHead>
                <TableCellHead align="left" padding="normal">
                  <b>Asunto</b>
                </TableCellHead>
                <TableCellHead align="center" padding="normal">
                  <b>Soporte</b>
                </TableCellHead>
                <TableCellHead align="center" padding="normal">
                  <b>Folios</b>
                </TableCellHead>
                <TableCellHead align="left" padding="normal">
                  <b>Situación</b>
                </TableCellHead>
                <TableCellHead align="center" padding="normal">
                  <b>Acciones</b>
                </TableCellHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredExp
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((expediente, index) => {
                return (
                  <TableRow
                    key={index}
                    sx={
                      index % 2 === 0
                        ? { backgroundColor: "#f2f2f2" }
                        : { backgroundColor: "#fff" }
                    }
                  >
                    <TableCell align="right" width="50">
                      <b>{expediente.numero}</b>
                    </TableCell>
                    <TableCell align="left" width="300">
                      {expediente.asunto}
                    </TableCell>
                    <TableCell align="center" width="100">
                      {expediente.soporte}
                    </TableCell>
                    <TableCell align="center" width="50">
                      {expediente.folios}
                    </TableCell>
                    <TableCell align="left" width="400">
                      {expediente.situacion}
                    </TableCell>
                    <TableCell align="center" width="100">
                      <>
                        <IconButton
                          title="Gestionar"
                          size="small"
                          component={Link}
                          to={{
                            pathname: "/ver_tramite/" + expediente.tramiteId,
                            state: { from: location },
                          }}
                        >
                        <AppRegistrationOutlinedIcon fontSize="small" />
                        </IconButton>
                        <BotonSeguir 
                          tramiteId={expediente.tramiteId}
                        ></BotonSeguir>
                        <IconButton
                          title="Quitar de la lista"
                          size="small"
                          onClick={() => handleQuitar(index)}
                        >
                          <RemoveCircleOutlineOutlinedIcon fontSize="small" />
                        </IconButton>
                      </>
                    </TableCell>
                  </TableRow>
                );
              })}
              {filteredExp.length === 0 ? (
                <TableRow>
                  <TableCell colSpan="6" align="center">
                    <Typography variant="aclaracion">
                      No se encontraron expedientes
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                  ""
                )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[
                    5,
                    10,
                    25,
                    { label: "Todos", value: filteredExp.length },
                  ]}
                  count={filteredExp.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  selected={selected}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </TabContainer>
   
    </Page >
  );
};

export default ConsultaSeguir;